import { Box } from "@fuegokit/react";
import React from "react";

function ImageWrapper({ children }) {
  return (
    <Box
      sx={{
        p: 6,
        bg: "background.neutral.default",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "border.default",
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          img: { maxWidth: "100%" },
          justifyContent: "center",
          display: "flex",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default ImageWrapper;
